define('shoptheme/components/customer/account/policy',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"text!shoptheme/templates/magnific-popup/default.html",
	"magnific-popup"
], function(
	$,
	_,
	Component,
	BEM,
	PopupHtml
) {
	var _popupTemplate = null;

	return Component.create({
		$init: function() {
			var self = this;
			var selector = '.' + BEM.buildElementClassname("privacy-optin", "agreements") + ' .checkbox a';

			$(document).on("click", selector, function(e) {
				var link = $(e.currentTarget);

				e.preventDefault();

				link.attr('href', link.attr('href').replace(/.*?:/g, ''));

				link.magnificPopup({
					type: 'ajax',
					callbacks: {
						parseAjax: function(mfpResponse) {
							var html = mfpResponse.data.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, '');

							mfpResponse.data = self._renderPopup({
								body: html
							});
						}
					}
				}).magnificPopup('open');
			});
		},

		_renderPopup: function(data) {
			if (null === _popupTemplate) {
				_popupTemplate = _.template(PopupHtml);
			}

			return _popupTemplate(data);
		}
	});
});
